import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { UnionServiceDelegation } from "DelegationService/DelegationService/Domain/Model/UnionServiceDelegation/UnionServiceDelegation";

export async function deleteUnionDelegationServiceService(unionDelegationServiceId) {
    let response = await getAPIResponse("/v1/union-service-delegation/" + unionDelegationServiceId, {}, "DELETE");
    if (response === null) {
        return null;
    }
    let unionDelegationService = UnionServiceDelegation.createFromResponseData(response);
    return unionDelegationService;
}